import { useMemo } from 'react'
import { useSelector } from 'react-redux'

export const useAuth = () => {
  const authSlice = useSelector((state) => state.auth)

  return useMemo(() => authSlice, [authSlice])
}
